'use strict';

const isMobileWidth = require('./modules/util/isMobileWidth');

const ROWS_PER_COL = 3;
const MULTICOL_EL = '.js-multicol';
const TEMPLATE = `
  <div class="collection-ingr-col">
    <ul class="collection-ingredients-list">
      $HTML
    </ul>
  </div>
`;

const convertToChunks = () => {
    const multicolListItem = Array.from(document.querySelector(MULTICOL_EL).children);
    const chunks = [];

    for (let i = 0; i < multicolListItem.length; i += ROWS_PER_COL) {
        const chunk = multicolListItem.slice(i, i + ROWS_PER_COL);
        chunks.push(chunk);
    }

    return chunks;
};

const renderCols = () => {
    const multicolEl = document.querySelector(MULTICOL_EL);
    const chunks = convertToChunks();

    multicolEl.innerHTML = '';

    for (const chunk of chunks) {
        let html = '';
        for (let i = 0; i < chunk.length; i += 1) {
            html += chunk[i].outerHTML;
        }
        html = TEMPLATE.replace('$HTML', html);
        multicolEl.insertAdjacentHTML('beforeend', html);
    }
};

const shouldInit = () => document.querySelectorAll(MULTICOL_EL).length > 0 && isMobileWidth();

const multiCol = {
    init: () => {
        if (shouldInit()) {
            renderCols();
        }
    }
};

module.exports = multiCol;
